module.exports = __webpack_public_path__ + "static/img/logo_white.5c48b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_white.png
// module id = s9k0
// module chunks = 11